import React from 'react';

const CTA = () => {
  const handleEmailClick = () => {
    let hasBlurred = false;
    const onBlur = () => { hasBlurred = true; };
    window.addEventListener('blur', onBlur);

    setTimeout(() => {
      window.removeEventListener('blur', onBlur);
      if (!hasBlurred) {
        const email = 'hello@ssrrlabs.com';
        const subject = encodeURIComponent('Project Inquiry - SSRR Labs');
        const body = encodeURIComponent('Hi SSRR Labs team,\n\nI would like to discuss a potential project with you.\n\nBest regards,');
        window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`, '_blank', 'noopener,noreferrer');
      }
    }, 600);
  };

  return (
    <section className="cta" id="contact">
      <div className="cta-inner">
        <div className="ey rev" style={{ justifyContent: 'center' }}>Get In Touch</div>
        <h2 className="rev">Ready to build something<br/><i>that matters?</i></h2>
        <p className="sec-p rev d1">
          Whether you need an AI product built from scratch,
          a technology partner for your next phase, or strategic
          advisory on your AI direction — let us talk.
        </p>
        <div className="cta-btns rev d2">
          <a href="mailto:hello@ssrrlabs.com?subject=Project%20Inquiry%20-%20SSRR%20Labs&body=Hi%20SSRR%20Labs%20team,%0A%0AI%20would%20like%20to%20discuss%20a%20potential%20project%20with%20you." onClick={handleEmailClick} className="cta-main">hello@ssrrlabs.com</a>
          <a href="https://linkedin.com/company/ssrrlabs" target="_blank" rel="noopener noreferrer" className="cta-sec">LinkedIn →</a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
